module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/xheadc2-2ead4fb1adb81424adbf383fd7d45029.jpg";